module.exports = __webpack_public_path__ + "img/transparent-nav-right-infiniti.01fafe03.png";